import { createSlice, Dispatch, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'
import { Steps } from '../../../models/Steps'

// Define the initial state for the slice, it is an empty array
const initialState: Steps = {
  currentStep: 0,
  completedSteps: [],
  workflowSteps: [],
  donationOptionsActive: false,
}

// Define the `answers` slice
export const stepsSlice = createSlice({
  name: 'steps',
  initialState,
  reducers: {
    setWorkflowSteps: (state, action: PayloadAction<string[]>) => {
      state.workflowSteps = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      if (!isValidStep(state, action.payload)) {
        state.currentStep = 0
      } else {
        state.currentStep = action.payload
      }
    },
    setCurrentStepAsCompleted: (state) => {
      state.completedSteps.push(state.currentStep)
    },
    setDonationOptionsActive: (state, action: PayloadAction<boolean>) => {
      state.donationOptionsActive = action.payload
    },
  },
})

const isValidStep = (state: Steps, step: number) => {
  // step X is only valid if step 0...X-1 are complete
  return state.completedSteps.length >= step
}

export const getCurrentStep = () => (_dispatch: Dispatch, getState: () => RootState) => {
  const steps = getState().order.steps

  return { number: steps.currentStep, label: steps.workflowSteps[steps.currentStep] }
}

// Export the `addStep` reducer
export const {
  setWorkflowSteps,
  setCurrentStep,
  setCurrentStepAsCompleted,
  setDonationOptionsActive,
} = stepsSlice.actions

// Export the `answers` reducer
export default stepsSlice.reducer
